import { Theme } from '../../../config/config.types';
import { TypographyProps, ColorProps } from 'styled-system';

type HTMLElementType = any;

export type Variant = 'primary' | 'secondary';

export enum VARIANT {
  PRIMARY = 'primary',
  SECONDARY = 'secondary',
}

export type Size = 'normal' | 'small';

export enum SIZE {
  BODY_TEXT = 'normal',
  SMALL_TEXT = 'small',
}

export type Weight = 'thin' | 'light' | 'normal' | 'medium' | 'semibold' | 'bold';

export enum WEIGHT {
  THIN = 'thin',
  LIGHT = 'light',
  NORMAL = 'normal',
  MEDIUM = 'medium',
  SEMIBOLD = 'semibold',
  BOLD = 'bold',
}

export type Element = 'p' | 'span';

export enum ELEMENT {
  P = 'p',
  SPAN = 'span',
}

export type Color = 'light' | 'error' | 'warning';

export enum COLOR {
  LIGHT = 'light',
  ERROR = 'error',
  WARNING = 'warning',
}

export { Theme };

export type StyledProps = TypographyProps & ColorProps & {};

export interface ComponentProps extends HTMLElementType, StyledProps {
  size?: Size;
  variant?: Variant;
  weight?: Weight;
  as?: Element;
  color?: Color | string;
}
